// First-party launch tracking: per-tab session id + UTM tags, no cookies, honours Do Not Track / GPC.
const KEY = "cdva_launch_session";
const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];

function optedOut() {
  if (typeof navigator === "undefined") return true;
  return navigator.doNotTrack === "1" || window.doNotTrack === "1" || navigator.globalPrivacyControl === true;
}

function newId() {
  if (window.crypto?.randomUUID) return window.crypto.randomUUID();
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
}

function loadSession() {
  let s = null;
  try {
    s = JSON.parse(sessionStorage.getItem(KEY) || "null");
  } catch (_) {}
  if (!s || !s.id) s = { id: newId(), utm: {}, visited: false };
  const params = new URLSearchParams(window.location.search);
  UTM_KEYS.forEach((k) => {
    const v = params.get(k);
    if (v) s.utm[k] = v.slice(0, 100);
  });
  return s;
}

function saveSession(s) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(s));
  } catch (_) {}
}

function send(type, button, s) {
  const body = JSON.stringify({
    type,
    button,
    path: window.location.pathname,
    session_id: s.id,
    ...s.utm,
  });
  const url = `${process.env.REACT_APP_BACKEND_URL}/api/marketing/track`;
  const blob = new Blob([body], { type: "text/plain" });
  try {
    if (navigator.sendBeacon && navigator.sendBeacon(url, blob)) return;
  } catch (_) {}
  fetch(url, { method: "POST", body, headers: { "Content-Type": "text/plain" }, keepalive: true }).catch(() => {});
}

export function trackLaunchVisit() {
  if (optedOut()) return;
  const s = loadSession();
  if (!s.visited) {
    s.visited = true;
    send("visit", null, s);
  }
  saveSession(s);
}

export function trackLaunchClick(type, button) {
  if (optedOut()) return;
  const s = loadSession();
  saveSession(s);
  send(type, button, s);
}
